export default __webpack_public_path__ + "static/media/img4.344d2c72.jpg";